import { render } from "./AllowList.vue?vue&type=template&id=8ffb4ca0&scoped=true"
import script from "./AllowList.vue?vue&type=script&lang=js"
export * from "./AllowList.vue?vue&type=script&lang=js"

import "./AllowList.vue?vue&type=style&index=0&id=8ffb4ca0&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ffb4ca0"]])

export default __exports__